import { useDialog } from "lib/@hooks/useDialog.js"
import { Bound } from "lib/@components/binding/Bound.js"
import { itemsInDialog } from "routes/schedule/lib/items-in-dialog.js"
import { GetTailoredCopyDialog } from "routes/schedule/plugins/custom-schedule-from-tailored/get-tailored-copy-dialog.js"

/**
 * A dialog that returns { treeId, scheduleNodeId } which can be used to acquire a tailored schedule
 * via getExtendedSchedule()
 *
 * @returns {Object|undefined} schedule - the schedule ready to be setup and made into a draft
 */
export function useSelectTailoredSchedule() {
    return useDialog(
        <Bound pageSizeCalculator={itemsInDialog(40, 0.7, 300)}>
            <GetTailoredCopyDialog />
        </Bound>,
        {
            dialogProps: { maxWidth: "lg", sx: { height: "100vh", width: "60vw", minWidth: 500 } },
        }
    )
}
